export enum ValidatorType {
    required = 'required',
    email = 'email',
    string = 'string',
    number = 'number'
}
